import { useEffect, useRef } from "react";
import {
  type NavigateOptions,
  type To,
  useLocation,
  useNavigate,
} from "react-router-dom";

const pathnameOf = (to: To) =>
  typeof to === "string" ? to.split(/[?#]/)[0] : (to.pathname ?? "");

export const useTabNavigate = () => {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();
  const pending = useRef<string | null>(null);

  useEffect(() => {
    pending.current = null;
  }, [key]);

  return (to: To, options?: NavigateOptions) => {
    const target = pathnameOf(to);
    if (target === pathname || target === pending.current) return;
    pending.current = target;
    void navigate(to, options);
  };
};
